import type { ReactNode } from 'react';

import type { TemplateType } from './types';

type SmartFormLayoutProps = {
  template: TemplateType;
  children: ReactNode;
  className?: string;
};

export function SmartFormLayout({
  template,
  children,
  className = '',
}: SmartFormLayoutProps) {
  if (template === 'bare') {
    return <div className={className}>{children}</div>;
  }

  if (template === 'card') {
    return (
      <div
        className={`rounded-lg border border-gray-200 bg-white p-6 shadow-sm ${className}`}
      >
        {children}
      </div>
    );
  }

  return <div className={className}>{children}</div>;
}
